import { FieldType } from './FieldType';
import { FilterExpressionType } from './FilterExpressionType';
import { FilterType } from './FilterType';

export class Filter {
  public fieldName: string;
  public fieldType: FieldType;
  public filterType: FilterType;
  public filterQuery: FilterExpressionType[];

  constructor(
    fieldName: string,
    fieldType: FieldType,
    filterType: FilterType,
    filterQuery: FilterExpressionType[]
  ) {
    this.fieldName = fieldName;
    this.fieldType = fieldType;
    this.filterType = filterType;
    this.filterQuery = filterQuery;
  }
}
